import React from 'react';
import { getLabel } from '../data/labels';
import BetsOddsHeader from '../common/BetsOddsHeader';
import Loader from '../common/Loader';
import PrematchContext from '../contexts/PrematchContext';
import { useFetch } from '../data/fetch/useFetch';
import { parseWidgetData } from '../data/parseWidgetData';
import { getConfiguration } from '../data/utils';
import PrematchTournamentMatch from '../prematch/prematch-home/PrematchTournamentMatch';
import MatchHeader from './MatchHeader';

export default function TopMatches() {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);

    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );

    if (isLoading || isError) {
        return <Loader error={isError} />;
    }

    function openEvent(event) {
        const tournamentUniqueId = `${event.sportRef}_${event.categoryRef}_${event.tournamentRef}`;
        prematchContext.openEvent(tournamentUniqueId, event);
    }

    const matchesByType = new Map();
    data.topMatches.forEach(match => {
        const matchBet = match.bets[0].id;
        const uniqueItemId = `${match.sportRef}_${match.tournamentRef}_${matchBet}`;
        if (!matchesByType.has(uniqueItemId)) {
            matchesByType.set(uniqueItemId, []);
        }
        matchesByType.get(uniqueItemId).push(match);
    });
    const items = Array.from(matchesByType.values());
    
    return (
        <div className="blocco-quote-espanse">
            <div className="contenitore-table bg-bianco collapse show bordo-tondo" id="tabella-c">
                <div className="contenitore-table bg-bianco collapse show bordo-tondo">
                    {items.map((matches, i) => {
                        const firstMatch = matches[0];
                        return(
                            <MatchHeader match={firstMatch} toggled={i < 3}>
                                <div className="tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch tabellaQuotePrematch_5col">
                                    <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                                    <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                        <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                                    </div>
                                    <div className="tabellaQuoteSquadre"></div>
                                    <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                        <BetsOddsHeader bets={firstMatch.bets} />
                                    </div>
                                    <div className="tabellaQuoteStatistiche"></div>
                                    <div className="tabellaQuoteAltre"></div>
                                </div>
                                {matches.map(match =>
                                    <PrematchTournamentMatch key={match.id}
                                                             match={match}
                                                             isLive={false}
                                                             isLastMinute={true}
                                                             openMatch={openEvent}
                                    />
                                )}
                            </MatchHeader>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
